import { Button } from '@yembo/yemblocks-core';

type Props = {
  onSubmit: () => void;
};

/*
Importance notice screen is shown in the Account Activation, Reset Password and Login flows.
Only for the prov_gov environment
*/

export const ImportanceNotice = ({ onSubmit }: Props) => (
  <div className='importance-notice'>
    <span className='notice-message'>
      IMPORTANT NOTICE: This is a restricted computer system and is for authorized use only. Usage of the system may be
      monitored, recorded, and audited by authorized personnel. Unauthorized usage of the system is prohibited and
      subject to criminal prosecution and/or civil law penalties. Use of this system by any user, authorized or
      unauthorized, constitutes consent to monitoring and recording. All data residing on this system should be
      considered confidential and is the property of the system owner. Attempts to access, change or export data on this
      system is prohibited and subject to criminal prosecution and/or civil law penalties.
    </span>
    <Button text='Continue' onClick={onSubmit} />
  </div>
);
